import React from 'react';
import PropTypes from 'prop-types';
import Wrapper from './Wrapper';
import Loading from '../common/Loading';
import LoadingResize from '../common/LoadingResize';

/**
 * BodyTable
 */
class BodyTable extends React.Component {

  componentDidMount() {
    this.props.actions.onMounted();
  }

  render() {
    return (
      <div className="fix_height">
        <Wrapper data={this.props.data} actions={this.props.actions} comactions={this.props.comactions} />
        <Loading />
        <LoadingResize />
      </div>
    );
  }
}

BodyTable.propTypes = {
  data: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired
};

export default BodyTable;
